import React, { useCallback } from "react";
import { Button, Modal } from "react-bootstrap";
import { formatDate } from "../utils/formatDate";
import { useCurrency } from "../_helper/currencyContext";

export const InvoiceModal = ({
    t,
    show,
    onHide,
    labInfo,
    testData,
    selectedCurrency,
    paidInSelectedCurrency,
    netTotalInSelectedCurrency,
    payment,                    // ← contains base currency values
    baseCurrency = "INR"        // fallback if not in user object
}) => {

    console.log(testData)
    const { getCurrencySymbol, convertCurrency } = useCurrency();

    const currencySymbol = getCurrencySymbol(selectedCurrency) || selectedCurrency;

    // Convert base currency amounts → selected currency
    const totalAmount = payment?.baseNetTotal > 0
        ? convertCurrency(payment?.baseNetTotal, baseCurrency, selectedCurrency)
        : 0;

    const discountInSelected = payment?.discount?.amount > 0
        ? convertCurrency(payment.discount.amount, baseCurrency, selectedCurrency)
        : 0;

    const taxInSelected = payment?.tax?.amount > 0
        ? convertCurrency(payment.tax.amount, baseCurrency, selectedCurrency)
        : 0;

    const subtotalInSelected = convertCurrency(
        payment?.totalPrice || 0,
        baseCurrency,
        selectedCurrency
    );

    const onPrint = useCallback(() => {
        const content = document.getElementById("invoice-content");
        if (!content) return;

        const printWin = window.open("", "", "width=800,height=900");
        printWin.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <style>
            body { margin:0; padding:0; font-family: Arial, sans-serif; font-size:12px; line-height:1.4; }
            .receipt { width:76mm; margin:0 auto; padding:15mm 2mm 10mm 2mm; }
            .center-block { width:100%; text-align:center !important; }
            .center-block * { text-align:center !important; }
            table { width:100%; border-collapse:collapse; }
            td { padding:3px 0; }
            .text-end { text-align:right; }
            .dotted { border-bottom:1px dotted #000; margin:6px 0; }
            @media print { @page { size:80mm auto; margin:0; } }
            .flex {display:flex; justify-content: space-between;}
          </style>
        </head>
        <body>
          <div class="receipt">${content.innerHTML}</div>
        </body>
      </html>
    `);

        printWin.document.close();
        printWin.focus();
        setTimeout(() => {
            printWin.print();
            printWin.close();
        }, 300);
    }, [testData, labInfo, t, selectedCurrency]);

    return (
        <Modal className="invoice-modal" show={show} onHide={onHide} scrollable centered>
            <Modal.Header>
                <Modal.Title>{t("Invoice Receipt")}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="tw-px-12">
                {labInfo && testData && (
                    <div id="invoice-content" className="pos-invoice" style={{ fontSize: "14px" }}>
                        {/* Header */}
                        <div className="text-center center-block mb-2">
                            {labInfo?.logo ? (
                                <img src={`${process.env.REACT_APP_IMAGE}${labInfo.logo}`} alt="logo" style={{ height: "70px", marginBottom: 5 }} />
                            ) : (
                                <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="logo" style={{ height: "40px", marginBottom: 5 }} />
                            )}
                            <p className="mt-1 mb-0 fw-bold">{labInfo?.facility_name}</p>
                            <small className="text-muted">{labInfo?.contact_person?.address}</small>
                            <br />
                            <small>{t("Tel")}: {labInfo?.contact_person?.mobile}</small>
                            
                        </div>

                        <div style={{ borderBottom: "1px dotted #000", margin: "6px 0" }} />

                        <div className="mb-2 d-flex justify-content-between flex">
                            <div><small>{t("Patient")}: <strong>{testData.order?.patient?.name}</strong></small></div>
                            <div><small>{formatDate(testData?.order?.createdAt)}</small></div>
                        </div>

                        <div style={{ borderBottom: "1px dotted #000", margin: "6px 0" }} />

                        {/* Test Items */}
                        <table style={{ width: "100%", fontSize: "12px", lineHeight: "1.3" }}>
                            <tbody>
                                {testData?.order?.allTests?.map((item, index) => (
                                    <React.Fragment key={`${item._id}-${index}`}>
                                        <tr>
                                            <td style={{ width: "60%", fontWeight: 600, wordBreak: "break-word" }}>
                                                {item.name}
                                            </td>
                                            <td style={{ width: "20%" }}></td>
                                            <td style={{ width: "20%", textAlign: "right", fontWeight: 600 }}>
                                                {currencySymbol} {convertCurrency(item.cost, baseCurrency, selectedCurrency).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="3" style={{ borderBottom: "1px dotted #000", padding: "2px 0" }} />
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>

                        {/* Summary Table - NOW FULLY CONVERTED */}
                        <table style={{ width: "100%", fontSize: "12px", marginTop: "5px" }}>
                            <tbody>
                                <tr>
                                    <td>{t("Subtotal")}</td>
                                    <td className="text-end">
                                        {currencySymbol} {subtotalInSelected.toFixed(2)}
                                    </td>
                                </tr>

                                {payment?.discount?.amount > 0 && (
                                    <tr>
                                        <td>{t("Discount")}{payment?.discount?.percentage ? ` (${payment.discount.percentage}%)` : ""}</td>
                                        <td className="text-end">
                                            -{currencySymbol} {discountInSelected.toFixed(2)}
                                        </td>
                                    </tr>
                                )}

                                {taxInSelected > 0 && (
                                    <tr>
                                        <td>{t("Tax")} ({payment?.tax?.percentage}%)</td>
                                        <td className="text-end">
                                            +{currencySymbol} {taxInSelected.toFixed(2)}
                                        </td>
                                    </tr>
                                )}

                                <tr>
                                    <td>{t("Total")}</td>
                                    <td className="text-end">
                                        {currencySymbol} {Number(netTotalInSelectedCurrency).toFixed(2)}
                                    </td>
                                </tr>

                                <tr>
                                    <td>{t("Paid")}</td>
                                    <td className="text-end">
                                        {currencySymbol} {Number(payment?.paid).toFixed(2)}
                                    </td>
                                </tr>

                                {Number(netTotalInSelectedCurrency - payment?.paid).toFixed(2) > 0 && (
                                    <tr>
                                        <td>{t("Due Amount")}</td>
                                        <td className="text-end">
                                            {currencySymbol} {(netTotalInSelectedCurrency - payment?.paid).toFixed(2)}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <div style={{ borderBottom: "1px dotted #000", margin: "6px 0" }} />
                        <div className="text-center center-block" style={{ marginTop: "10px" }}>
                            <p style={{ margin: 0 }}>
                                <strong>{t("Thank you for your business")}</strong>
                            </p>
                        </div>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="primary" onClick={onPrint}>
                    {t("Print")}
                </Button>
                <Button variant="secondary" onClick={onHide}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default InvoiceModal;